import React, { useContext } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { ResultsMenuSport } from "@data-types/results";
import { ResultsMenuStoreContext } from "@state/context/results";
import classnames from "classnames";
import OfferIcon from "@components/icons/Offer";

export default observer(function ResultsSportItem({
	sport,
}: {
	sport: ResultsMenuSport;
}) {
	const store = useContext(ResultsMenuStoreContext);
	const isSelected = computed(() => store.isSportSelected(sport.id)).get();

	const buttonClasses = classnames("nav--secondary__link", {
		"is-expanded": store.selectedSportId === sport.id,
		"is-selected": isSelected,
	});

	const iconClasses = classnames(
		"nav--secondary__icon__inner u-icon u-icon--lrg u-icon--sport u-icon--sport--color",
		{
			"is-selected": isSelected,
		}
	);

	return (
		<li className="nav--secondary__item nav--sports__regular">
			<button
				type="button"
				className={buttonClasses}
				onClick={() => {
					if (store.selectedSportId !== sport.id) {
						store.setSelectedSport(sport);
						if (!store.isMenuExpanded) {
							store.toggleMenuExpanded();
						}
					} else {
						store.setSelectedSport(null);
						store.toggleMenuExpanded();
					}
				}}
			>
				<div className="nav--secondary__icon">
					<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
						{sport.count}
					</span>
					<OfferIcon
						type="sport"
						sport={sport.abrv}
						className={iconClasses}
					/>
				</div>
				<div className="nav--secondary__title">{sport.name}</div>
			</button>
		</li>
	);
});
